module.exports = "<div #vc></div>\n"